import { render } from "./UIconButton.vue?vue&type=template&id=331ae575"
import script from "./UIconButton.vue?vue&type=script&lang=ts"
export * from "./UIconButton.vue?vue&type=script&lang=ts"
script.render = render

export default script